import { useCallback, useEffect, useState } from 'react';

/**
 * Navegação, em trinta linhas.
 *
 * Um roteador de biblioteca resolveria o mesmo e traria mais dependência do que
 * o Hub precisa hoje: são três endereços. Se um dia virarem quinze, aí sim.
 *
 * O endereço no navegador importa: "manda o link daquele cliente" é pedido
 * corriqueiro, e sem endereço próprio não há link a mandar.
 *
 * O nginx do container já devolve o `index.html` para qualquer caminho
 * (`try_files`), então recarregar a página em `/clientes/abc` funciona.
 */
/**
 * ⭐ **A GUARDA DE SAÍDA — 15/10/2026 (a ficha do post, PRD §50.5).**
 *
 * A página com texto por gravar registra uma guarda; o clique no menu passa
 * por ela antes de trocar de endereço. Se ela devolve `true`, a troca não
 * acontece agora: a página pergunta "descartar?" com a pergunta da casa
 * (`GuardaDoFormulario`) e, no sim, tira a guarda e chama `ir` de novo.
 *
 * ⚠️ **Só uma de cada vez, e só quem registrou tira.** Sem guarda, `ir` é o
 * de sempre. ⚠️ O botão "voltar" do navegador não passa por aqui (o
 * `popstate` não se cancela); o fechamento da aba passa pelo `beforeunload`
 * da própria página.
 */
let guardaDeSaida: ((destino: string) => boolean) | null = null;

export function guardarSaida(guarda: (destino: string) => boolean): () => void {
  guardaDeSaida = guarda;
  return () => {
    if (guardaDeSaida === guarda) guardaDeSaida = null;
  };
}

export function usarRota() {
  const [caminho, setCaminho] = useState(() => window.location.pathname);

  useEffect(() => {
    // O botão "voltar" do navegador precisa funcionar. Sem isto ele muda o
    // endereço e a tela fica onde estava — o pior dos dois mundos.
    const aoVoltar = () => setCaminho(window.location.pathname);
    window.addEventListener('popstate', aoVoltar);
    return () => window.removeEventListener('popstate', aoVoltar);
  }, []);

  const ir = useCallback((novo: string) => {
    if (novo === window.location.pathname) return;
    if (guardaDeSaida?.(novo)) return;
    window.history.pushState(null, '', novo);
    setCaminho(novo);
    window.scrollTo(0, 0);
  }, []);

  return { caminho, ir };
}
